import React from "react";
import { getTexts } from "../utils/i18n";

const FileUpladLoader: React.FC = () => {
    const texts = getTexts();

    return (
        <div className="fullscreen-popup" id="aiChatPopupLoading">
            <div className="popup-content">
                <p>{texts.analyzingDocuments}</p>

                <div className="loading-message col-12">

                    <div className="loading-dots">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default FileUpladLoader;
